import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    "@keyframes onload": {
        "0%": {
            opacity: 0,
        },
        "100%": {
            opacity: 1,
        }
    },
    "@keyframes onloadup": {
        "0%": {
            opacity: 0,
            transform: "translateY(32px)"
        },
        "100%": {
            opacity: 1,
            transform: "translateY(0)"
        }
    },
    resourcesContainer: {
        position: 'relative',
        height: 'auto',
        zIndex: 99,
        background: '#F5F5F5',
        color: '#4a4a4a',
        fontSize: 16,
        letterSpacing: '-0.5px',
        padding: '34px 35px',
        animationName: `$onload`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 1200px)': {
            paddingLeft: 110,
        },
        '@media(max-width: 768px)': {
            padding: 30,
        },
        '@media(max-width: 480px)': {
            padding: 20,
        }
    },
    resourcesContainerInner: {
        maxWidth: '1110px',
        position: 'relative',
        height: '100%'
    },
    resourcesHeader: {
        width: '100%',
        marginBottom: 22,
        lineHeight: '28px',
        position: 'relative',
        '& h1': {
            fontSize: '2rem',
            fontWeight: '600',
            lineHeight: '1.235',
            margin: '0',
        },
        '& p': {
            margin: '5px 0 0 0',
            padding: '0',
            lineHeight: '1.13',
            color: '#4a4a4a',
        },
        '& button': {
            position: 'absolute',
            right: 0,
            bottom: 0,
            height: '18px',
            cursor: 'pointer',
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '1.13',
            color: '#2d91e9',
            padding: '0 10px 0 0',
            border: 'none',
            background: 'transparent',
            [theme.breakpoints.down('md')]: {
                bottom: 'auto',
                top: 5,
            },
            '&:focus, &:active': {
                outline: 'none',
            },
            '& svg': {
                verticalAlign: 'bottom',
                fontSize: '120%',
                width: '1em',
                height: '1em',
                fill: 'currentColor'
            }
        }
    },
    resourcesCardsWrapper: {
        marginBottom: 30,
        '& .MuiGrid-item.MuiGrid-grid-xs-3': {
            maxWidth: '20%',
            flexBasis: '20%'
        },
        '& .MuiGrid-item.MuiGrid-grid-xs-3 > div > div:first-child': {
            height: 240,
        }
    },
    resourcesCardsItem: {
        opacity: 0,
        cursor: 'pointer',
        position: 'relative',
        backgroundColor: '#fff',
        boxSizing: 'border-box',
        textAlign: 'center',
        animationName: `$onloadup`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
        '&:hover': {
            boxShadow: '0 0px 20px 2px rgba(0,0,0,0.15)',
            '& button': {
                opacity: 1
            }
        },
    },
    resourcesCardsItemCorner: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 50,
        height: 50,
        color: '#a4a4a4',
        '& > span': {
            display: 'inline-block',
            width: 0,
            height: 0,
            borderStyle: 'solid',
            borderWidth: '0 50px 50px 0',
            borderColor: 'transparent #f5f5f5 transparent transparent',
            position: 'absolute',
            top: 0,
            right: 0,
        },
        '& > svg': {
            width: '1em',
            height: '1em',
            position: 'absolute',
            top: 7,
            fontSize: '115%',
            right: 5,
            fill: 'currentColor'
        }
    },
    resourcesCardsItemSpinner: {
        position: 'absolute',
        top: 300,
        right: 0,
        left: 0,
        margin: 'auto',
    },
    resourcesCardsImgSpinner: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        margin: 'auto',
    },
    resourcesCardsItemImg: {
        padding: '35px',
        display: 'flex',
        height: 350,
        boxSizing: 'border-box',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        '&.pdf': {
            padding: 15
        }
    },
    resourcesCardsItemImgOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        margin: 'auto',
        opacity: 0,
        transitionProperty: 'all',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease-in-out',
        backgroundColor: 'rgba(255,255,255,0.50)',
        '&:hover': {
            opacity: 1
        },
    },
    resourcesCardsItemImgTag: {
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%'
    },
    resourcesCardsItemEmbedTag: {
        width: '100%',
        height: '100%'
    },
    resourcesCardsItemText: {
        padding: '10px 20px',
        backgroundColor: '#f3f3f3',
        minHeight: 65,
        boxSizing: 'border-box',
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'center',
        '& span': {
            display: 'block',
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }
    },
    resourcesCardsItemTextTitle: {
        color: '#2D91E9',
        fontWeight: 500,
        fontSize: 15,
        margin: '0 auto 2px'
    },
    resourcesCardsItemTextSub: {
        color: '#a4a4a4',
        fontWeight: 400,
        fontSize: 14
    },

    resourcesCardsItemBtn: {
        position: 'absolute',
        top: '2em',
        bottom: 0,
        margin: 'auto',
        width: '160px',
        left: 0,
        right: 0,
        opacity: 0,
        transitionProperty: 'all',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease-in-out',
    },
    loadMoreButton: {
        display: 'block',
        width: 190,
        margin: '0 auto 1.875rem',
        color: "#2D91E9",
        border: "1px solid #E8E8E8",
        background: "transparent",
        "&:hover": {
            background: "transparent",
            border: "1px solid #2D91E9",
        },
        '@media(max-width: 480px)': {
            width: '100%',
        }
    },
    loadMoreButtonSpinner: {
        display: 'block',
        margin: '0 auto 2.8rem',
        maxWidth: 30,
        maxHeight: 30
    },
    // Filters
    filtersMobileToggle: {
        display: 'none',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            fontWeight: 600,
            alignItems: 'center',
            padding: 20,
            background: 'white',
            cursor: 'pointer',
            boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
            border: 'none',
            outline: 'none',
            width: '100%',
            boxSizing: 'border-box',
            '& > svg': {
                marginRight: 6,
                top: -1,
                position: 'relative'
            }
        },
    },
    filtersMobileToggleClosed: {
        marginBottom: 30,
    },
    filtersBarMobileOpen: {
        [theme.breakpoints.down('md')]: {
            display: 'block'
        }
    },
    filtersBarMobileClosed: {
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    filtersBar: {
        position: 'relative',
        backgroundColor: '#fff',
        marginBottom: 30,
        padding: '20px 110px 20px 30px',
        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)',
        [theme.breakpoints.down('md')]: {
            padding: '0 20px 20px 20px',
        },
        '& nav > ul': {
            margin: 0,
            display: 'grid',
            padding: 0,
            flexWrap: 'wrap',
            listStyle: 'none',
            alignItems: 'center',
            gridTemplateColumns: 'auto auto auto auto auto',
            justifyContent: 'flex-start',
            gridColumnGap: 15,
            gridRowGap: 15,
            [theme.breakpoints.down('md')]: {
                gridTemplateColumns: '100%',
            },
            '& > li': {
                listStyle: 'none',
                margin: 0,
                padding: 0,
                position: 'relative',
                [theme.breakpoints.down('md')]: {
                },
                '&:first-child': {
                    fontWeight: 600,
                    [theme.breakpoints.down('md')]: {
                        display: 'none'
                    }
                },
            },
        }

    },
    filtersBarIcons: {
        width: 50,
        height: 20,
        position: 'absolute',
        right: 30,
        top: 34,
        [theme.breakpoints.down('md')]: {
            display: 'none'
        },
        '& ul, & ul li': {
            listStyle: 'none',
            margin: 0,
            padding: 0,
        },
        '& ul': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& li': {
                cursor: 'pointer',
                '&.is-active': {
                    color: '#2d91e9'
                },
                '& svg': {
                    fill: 'currentColor',
                    [theme.breakpoints.down('md')]: {
                        width: 15,
                    },
                },
            },
        },
    },
    emptyResults: {
        width: '100%',
        textAlign: 'center',
        padding: '5em 1em',
        margin: 'auto',
        '& svg': {
            maxWidth: 180,
            marginBottom: '2rem'
        },
        '& h2': {
            margin: '0 0 1.5rem 0'
        },
        '& p': {
            lineHeight: '1.6',
        },
    }
});
